import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { nativeNotify } from "@/lib/notify";

const POLL_MS = 60_000;
const PIPELINE_ROUTE = {
  mbbs: "/admin",
  general: "/admin/leads",
  counseling: "/admin/counselings",
};
const HOT = new Set(["Hot", "Warm"]);

export default function LeadAssignmentNotifier() {
  const nav = useNavigate();
  // Only notify for assignments that happen while the app is open.
  const sinceRef = useRef(new Date().toISOString());
  const seenRef = useRef(new Set());

  const check = useCallback(async () => {
    let items = [];
    try {
      const { data } = await api.get(`/admin/my-assignments/recent?since=${encodeURIComponent(sinceRef.current)}`);
      items = data?.items || [];
    } catch {
      return;
    }
    for (const it of items) {
      const key = `${it.id}|${it.claimed_at}`;
      if (seenRef.current.has(key)) continue;
      seenRef.current.add(key);
      const hot = HOT.has(it.lead_temperature);
      const title = hot ? `🔥 New ${it.lead_temperature} lead assigned to you` : "👤 New lead assigned to you";
      nativeNotify(title, {
        body: `${it.name}${it.phone ? ` · ${it.phone}` : ""}`,
        tag: `assign-${it.id}`,
        onClick: () => {
          const route = PIPELINE_ROUTE[it.pipeline] || "/admin/leads";
          nav(`${route}?focus=${it.id}`);
        },
      });
      toast(title, { description: it.name });
    }
    // advance the window so we never re-fetch the same rows
    sinceRef.current = new Date().toISOString();
  }, [nav]);

  useEffect(() => {
    const id = setInterval(check, POLL_MS);
    return () => clearInterval(id);
  }, [check]);

  return null;
}
